const baseUrl = process.env.REACT_APP_SPINNER_API_URL as string

export default baseUrl